import React, { useState, useEffect } from 'react';
import './Hero.css';

const MOCKUP_TABS = [
    {
        id: 'concierge',
        label: 'Concierge',
        image: '/laptopelyconciergeclear.webp',
        tagline: 'Hospitality guest requests, services & operations management.',
        description: 'Empower guests to request amenities, order room services, book spa appointments, and communicate directly with staff in real time.'
    },
    {
        id: 'fleet',
        label: 'Fleet',
        image: '/laptopelyfleetclear.webp',
        tagline: 'Real-time vehicle tracking, dispatch logistics & fuel analytics.',
        description: 'Coordinate guest shuttles, buggy transfers, and luggage deliveries with live GPS tracking, route optimization, and driver telemetry.'
    },
    {
        id: 'dine',
        label: 'Dine',
        image: '/laptopelydineclear.webp',
        tagline: 'Smart dining, digital menus & tableside QR ordering.',
        description: 'Streamline restaurant and in-room dining with interactive multi-language QR menus, direct POS sync, and kitchen display routing.'
    },
    {
        id: 'inventory',
        label: 'Inventory',
        image: '/laptopelyventoryclear.webp',
        tagline: 'Centralized stock tracking, automated procurement & consumption analytics.',
        description: 'Eliminate stockouts and reduce food waste with automated low-stock reorders, batch tracking, and cross-department requisition approvals.'
    }
];

const Hero = ({ darkMode = false }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [activeMockupIndex, setActiveMockupIndex] = useState(0);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    const scrollToMockup = () => {
        const mockupEl = document.querySelector('.hero-mockup-wrapper');
        if (mockupEl) {
            mockupEl.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <main className={`hero ${isLoaded ? 'loaded' : ''}`}>
            <div className="hero-content">
                <div className="hero-header-container">
                    <h1 className="hero-headline">
                        <span className="hero-headline-line">The Connected Platform</span>
                        <span className="hero-headline-line">Powering Modern Hospitality</span>
                        <span className="hero-headline-line">Across Every Department</span>
                    </h1>

                    <p className="hero-subtitle">
                        Unify guest concierge, digital dining, fleet logistics, and real-time inventory into one frictionless system built for resorts and hotels.
                    </p>

                    <div className="hero-cta-group">
                        <a href="#services" className="hero-btn-primary">
                            Explore Our Solutions
                        </a>
                        <button 
                            type="button" 
                            onClick={scrollToMockup}
                            className="hero-btn-secondary"
                            aria-label="See our platform in action"
                        >
                            See It in Action
                            <svg className="hero-btn-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M7 13l5 5 5-5M7 6l5 5 5-5"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <div className="hero-mockup-wrapper">
                    <div className="hero-mockup-container">
                        <img
                            src={MOCKUP_TABS[activeMockupIndex].image}
                            alt={MOCKUP_TABS[activeMockupIndex].label}
                            className="hero-mockup-img"
                            width="3948"
                            height="2143"
                            loading="eager"
                        />
                    </div>

                    <div className="mockup-tabs-container">
                        <div className="mockup-tabs" role="tablist" aria-label="Product Showcase">
                            {MOCKUP_TABS.map((tab, idx) => (
                                <button
                                    key={tab.id}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeMockupIndex === idx}
                                    className={`mockup-tab-btn tab-${tab.id} ${activeMockupIndex === idx ? 'active' : ''}`}
                                    onClick={() => setActiveMockupIndex(idx)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                        {MOCKUP_TABS[activeMockupIndex].tagline && (
                            <p className="mockup-tab-tagline">
                                {MOCKUP_TABS[activeMockupIndex].tagline}
                            </p>
                        )}
                        {MOCKUP_TABS[activeMockupIndex].description && (
                            <p className="mockup-tab-description">
                                {MOCKUP_TABS[activeMockupIndex].description}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Hero;